// This does 2 things:
// When the timer reaches zero, it changes the collection card to “LAUNCH IS LIVE” and “REFRESH TO SHOP”.
// When customer clicks the button, it reloads the page, then Liquid will render the card as normal launched/shop state.


(function () {
  window.CustomLaunchCardCountdown = window.CustomLaunchCardCountdown || {
    intervals: [],

    pad: function (number) {
      return String(number).padStart(2, '0');
    },

    init: function () {
      var countdowns = document.querySelectorAll('[data-custom-launch-countdown]');

      countdowns.forEach(function (countdown) {
        if (countdown.dataset.initialized === 'true') return;
        countdown.dataset.initialized = 'true';

        var launchDatetime = countdown.getAttribute('data-launch-datetime');
        if (!launchDatetime) return;

        var launchDate = new Date(launchDatetime);
        if (isNaN(launchDate.getTime())) return;

        var cardWrapper = countdown.closest('.custom-launch-card-wrapper');
        var daysEl = countdown.querySelector('[data-days]');
        var hoursEl = countdown.querySelector('[data-hours]');
        var minutesEl = countdown.querySelector('[data-minutes]');
        var secondsEl = countdown.querySelector('[data-seconds]');

        function setRefreshState() {
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';

          countdown.classList.add('is-ready-to-refresh');

          if (!cardWrapper) return;

          cardWrapper.classList.add('is-ready-to-refresh');

          var badge = cardWrapper.querySelector('.custom-launch-card__badge');
          var status = cardWrapper.querySelector('.custom-launch-card__status');
          var button = cardWrapper.querySelector('.custom-launch-card__button');

          if (badge) {
            badge.textContent = 'LAUNCH IS LIVE';
            badge.classList.remove('custom-launch-card__badge--soon');
            badge.classList.add('custom-launch-card__badge--launched');
          }

          if (status) {
            status.innerHTML = 'Launch time is here — refresh to shop now.';
            status.classList.remove('custom-launch-card__status--soon');
            status.classList.add('custom-launch-card__status--launched');
          }

          if (button) {
            button.textContent = 'REFRESH TO SHOP';
            button.classList.remove('custom-launch-card__button--notify');
            button.classList.add('custom-launch-card__button--shop');
            button.setAttribute('href', window.location.href);
            button.setAttribute('data-refresh-to-shop', 'true');
          }
        }

        function updateCountdown() {
          var now = new Date();
          var distance = launchDate.getTime() - now.getTime();

          if (distance <= 0) {
            setRefreshState();
            return;
          }

          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
          var minutes = Math.floor((distance / (1000 * 60)) % 60);
          var seconds = Math.floor((distance / 1000) % 60);

          if (daysEl) daysEl.textContent = CustomLaunchCardCountdown.pad(days);
          if (hoursEl) hoursEl.textContent = CustomLaunchCardCountdown.pad(hours);
          if (minutesEl) minutesEl.textContent = CustomLaunchCardCountdown.pad(minutes);
          if (secondsEl) secondsEl.textContent = CustomLaunchCardCountdown.pad(seconds);
        }

        if (cardWrapper) {
          cardWrapper.addEventListener('click', function (event) {
            var refreshTarget = event.target.closest('[data-refresh-to-shop="true"]');

            if (!refreshTarget) return;

            event.preventDefault();
            window.location.reload();
          });
        }

        updateCountdown();
        window.CustomLaunchCardCountdown.intervals.push(setInterval(updateCountdown, 1000));
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.CustomLaunchCardCountdown.init();
  });

  document.addEventListener('shopify:section:load', function () {
    window.CustomLaunchCardCountdown.init();
  });

  window.CustomLaunchCardCountdown.init();
})();